import React, { useState } from "react";

const Background = (props) => {

    const colors = {
        darkblue: "#003544",
        blue: "#05a2cb",
        green: "#89ba17",
        lightblue: "#cdecf5",
    };

    const [circles, setCircles] = useState([
        [0, 200, 500, "#cdecf5", 0.4],
        [1500, 700, 800, "#05a2cb", 0.2],
        [600, 3500, 1500, "#003544", 0.2],
        [750, 100, 50, "#cdecf5", 0.2],
        [150, 1500, 250, "#cdecf5", 0.4]

    ])

    //Parallax

    //on scoll make circles get bigger / smaller?

    /*        const {wachsen} = useParallax ({
                scale: [0.5, 1, 'easeInQuad'],
            });

            const schrumpfen = useParallax < HTMLDivElement > ({
                scale: [1.5, 1, 'easeInQuad'],
            });

     */
    //different layers for depth effect?

    const createCircles = () => {
        const circleSVGs = [];
        circles.forEach((circleData, index) => {
            const fillColor = circleData[3];
            const opacity = circleData[4];

            // Validate opacity and color
            if (typeof fillColor === 'string' && typeof opacity === 'number' && opacity >= 0 && opacity <= 1) {
                const opacityHex = Math.floor(opacity * 255).toString(16).padStart(2, '0');
                const fillWithOpacity = `${fillColor}${opacityHex}`;
                circleSVGs.push(
                    <circle key={index} cx={circleData[0]} cy={circleData[1]} r={circleData[2]} fill={fillWithOpacity} />
                );
            } else {
                console.error(`Invalid data for circle at index ${index}: ${JSON.stringify(circleData)}`);
            }
        });
        return circleSVGs;
    };


    return (
        <div className="background-svg" aria-hidden="true" focusable="false">
            <svg width="100%" height="100%">
                {createCircles()}
            </svg>
        </div>
    );
}

export default Background;